<template>
    <b-modal :id="id" v-model="modalAberto" size="xl" @hidden="cancelar" @close="cancelar" button-size="md" hide-footer
        :title="prefix + title">
        <produto-list :podeMudarSituacao="podeMudarSituacao" :podeMudarTipo="podeMudarTipo" :grupoProduto="grupoProduto"
            :idAta='idAta' @onDblClickProduto="produtoSelect" />
    </b-modal>
</template>

<script>
import ProdutoList from "@/modules/cadastros/produto/ProdutoList.vue"

export default {
    name: "ModalConsultaProdutoCadastroEssencial",
    components: {
        ProdutoList,
    },
    props: {
        podeMudarSituacao: {
            type: Boolean,
            default: true,
        },
        podeMudarTipo: {
            type: Boolean,
            default: true,
        },

        id: String,
        title: {
            type: String,
            default: "Produto",
        },
        prefix: {
            type: String,
            default: "",
        },
        idAta: {
            type: Number,
            default: null,
        },
        grupoProduto: {
            type: Number,
            default: null,
        }

    },
    data() {
        return {
            modalAberto: true,
        }
    },
    methods: {
        cancelar() {
            this.$emit("onselect")
            this.modalAberto = false

        },

        produtoSelect(produto) {
            this.$emit("onselect", produto)
            this.modalAberto = false
        },
    },
}
</script>
